import { ASSET_METADATA_KEY } from '../constants/data';
import { JOB_STATUS_PENDING_USER } from '../constants/jobs';

type AiMetadataJob = {
  id: string;
  status?: string | null;
};

export const getAiMetadataJobAssetSearch = (job: AiMetadataJob): string => {
  const params = new URLSearchParams({ open_panel: ASSET_METADATA_KEY });
  if (job.status === JOB_STATUS_PENDING_USER) {
    params.set('job_id', job.id);
  }
  return params.toString();
};
